import { LoaderIcon } from "../../../assets";
import "./PageLoader.scss"
interface PropsData {
    minHeight?: string;
    width?: number;
    className?: string
}
const PageLoader = ({ minHeight = '500px', width = 150, className }: PropsData) => {
    return (
        <>
            <div style={{ minHeight: minHeight }} className={`${className} table-loader` || 'table-loader'}>
                <div className="loader-icon">
                    <img src={LoaderIcon} width={width} alt="" style={{ background: 'transparent' }} />
                </div>
            </div>
        </>
    )
}
export default PageLoader;